import React from "react";

// API functions for task management
const API_URL = process.env.REACT_APP_API_URL || 'https://localhost:7204';

/**
 * Add a new task
 * @param {Object} issueData - Task data
 * @returns {Promise<Object>} - API response
 */
export const addIssue = async (issueData) => {
  try {
    const response = await fetch(`${API_URL}/api/Issue/AddIssue`, {
      method: 'POST',
         headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(issueData),
    });

    // Check if response is successful
    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`שגיאת שרת: ${response.status}`);
    }

    // Check if response is JSON
    const contentType = response.headers.get('content-type');
    if (!contentType || !contentType.includes('application/json')) {
      const responseText = await response.text();
      throw new Error('השרת החזיר תשובה לא תקינה');
    }

    return await response.json();
  } catch (error) {
    throw error;
  }
};